<template lang="pug">
  Modal(v-if="uploader")
    Gallery(:uploader="uploader")
</template>
<style>
/* Clamp: vue-fineuploader placeholder.vue ships inline max-height/width without px — invalid CSS, so videos show an unbounded SVG. */
.vue-fine-uploader-thumbnail-container {
  max-width: 130px;
  max-height: 130px;
  overflow: hidden;
}
.vue-fine-uploader-thumbnail-placeholder,
.vue-fine-uploader-thumbnail-placeholder svg {
  max-width: 100%;
  max-height: 100%;
}
</style>
<script>
import Modal from '../general/Modal';
import Spinner from '../general/Spinner';
import moment from 'moment';
import Gallery from 'vue-fineuploader/gallery';
import FineUploaderS3 from 'fine-uploader-wrappers/s3';
import { postResource } from '../../services/Utils.js';
import Services from '../../services/Services.js';
import store from '../../store';

function refreshActiveMediaList() {
  const market = store.getters.getActiveMarket;
  const tab = store.getters.getActiveMediaTab;
  if (!market || !market._id) return;
  if (tab && tab._id === 'featured') {
    Services.getMediaByMarket(market._id, 'featured', false, false, false);
  } else if (tab && tab.type === 'mediaLibrary') {
    Services.getMediaByMarket(market._id, tab._id, false, false, false);
  } else if (tab && tab.type === 'productGroup') {
    Services.getMediaByMarket(market._id, false, tab._id, false, false);
  } else if (tab && tab._id === 'none') {
    Services.getMediaByMarket(market._id, 'none', false, false, false);
  } else {
    Services.getMediaByMarket(market._id);
  }
}

export default {
  name: 'MediaUploadModal',
  components: {
    Gallery,
    Modal,
    Spinner
  },
  computed: {
  },
  data() {
    return {
      loadedUploader: false,
      uploader: null,
    };
  },
  methods: {
    setupUploader: () => new Promise(async (resolve, reject) => {
      try {
        const res = await postResource('/v1/media/sign');
        const fineUploader = new FineUploaderS3({
          options: {
            request: {
              endpoint: 'https://uploads-mediamobz-com.s3.amazonaws.com',
              accessKey: 'AKIAICDZPSI6TDKJZCWA',
              version: 4
            },
            signature: {
              endpoint: `https://glxstudio.com/api/pub/upload?expire=${res.stamp}&sig=${encodeURIComponent(res.sig)}&id=${encodeURIComponent(res.id)}`,
            },
            callbacks: {
              onComplete: (id, name, response, xhr) => {
                postResource(`/v1/media/upload?expire=${res.stamp}&sig=${encodeURIComponent(res.sig)}&id=${encodeURIComponent(res.id)}`, false, {
                  'media-key': fineUploader.methods.getKey(id),
                  name,
                  market: store.getters.getActiveMarket._id,
                  tab: store.getters.getActiveMediaTab,
                })
                  .then((res2) => {
                    if (res2.status === 'success') {
                      store.commit('setMediaLoadedStatus', false);
                      refreshActiveMediaList();
                      return store.commit('showMediaUploadModal', false);
                    } else {
                      return store.commit('showMediaUploadModal', false);
                    }
                  })
                  .catch(err => console.log(err));
              },
            },
          },
        });
        return resolve(fineUploader);
      } catch (error) {
        return reject(error);
      }
    }),
  },
  mounted() {
    this.setupUploader()
      .then((uploader) => {
        this.uploader = uploader;
      })
      .catch(error => console.log(error));
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modals/MediaUpload.vue